var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
let allStores = [];
export const getStores = () => {
    return allStores;
};
const queryStores = () => __awaiter(void 0, void 0, void 0, function* () {
    if (allStores.length === 0) {
        const currentVersion = localStorage.getItem('TH-stores_V');
        if (currentVersion && currentVersion === `${window.thGeolocationData.version}`) {
            allStores = JSON.parse(localStorage.getItem('TH-stores'));
            allStores.forEach((region, index) => {
                window.thGeolocationData.stores[index].availableCountries = region.availableCountries;
                window.thGeolocationData.stores[index].defaultCountry = region.defaultCountry;
            });
        }
        else {
            const localizationData = yield Promise.all(window.thGeolocationData.stores.map((store) => __awaiter(void 0, void 0, void 0, function* () { return yield queryShopifyStoreLocalization(store.permanent_domain, store.s); })));
            if (localizationData) {
                localizationData.forEach((region, index) => {
                    window.thGeolocationData.stores[index].availableCountries = region.availableCountries;
                    window.thGeolocationData.stores[index].defaultCountry = region.defaultCountry;
                });
                allStores = window.thGeolocationData.stores;
                localStorage.setItem('TH-stores', JSON.stringify(window.thGeolocationData.stores));
                localStorage.setItem('TH-stores_V', `${window.thGeolocationData.version}`);
            }
        }
    }
    return allStores;
});
const queryShopifyStoreLocalization = (myShopifyURL, token) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield fetch(`https://${myShopifyURL}/api/2022-07/graphql.json`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-Shopify-Storefront-Access-Token': token,
        },
        body: JSON.stringify({
            query: `
            query {
                localization {
                availableCountries {
                    currency {
                    isoCode
                    name
                    symbol
                    }
                    isoCode
                    name
                    unitSystem
                }
                defaultCountry: country {
                    currency {
                    isoCode
                    name
                    symbol
                    }
                    isoCode
                    name
                    unitSystem
                }
                }
            }
         `,
        }),
    });
    const data = yield res.json();
    return data.data.localization;
});
export function setGeolocationDataAsync() {
    return __awaiter(this, void 0, void 0, function* () {
        yield queryStores();
        if (sessionStorage.getItem('countryCode') === null) {
            const response = yield fetch('https://thread-ip.azurewebsites.net/api/ip');
            const data = yield response.json();
            sessionStorage.setItem('countryName', data.country);
            sessionStorage.setItem('countryCode', data.countryCode);
        }
    });
}
(() => __awaiter(void 0, void 0, void 0, function* () {
    yield queryStores();
}))();
